import toaster, { Toast } from 'react-hot-toast';

import { mergeClasses } from '@/utils';

import { CheckCircleIcon, CloseIcon } from '@/assets/icons';

import styles from './Alert.module.css';

interface ICustomSuccessToast {
  message: string;
  subtitle?: string;
  t: Toast;
}

const ToastSuccess: React.FC<ICustomSuccessToast> = ({
  message,
  subtitle,
  t,
}: ICustomSuccessToast) => {
  return (
    <div
      className={mergeClasses(
        'text-neutral-0 font-semibold text-body-sm min-w-[400px] max-w-[540px] flex items-center justify-between rounded-xs px-base !py-3 md:!py-4 bg-semantic-success-base dark:bg-green-dark gap-6',
        t.visible ? styles['animate-enter'] : styles['animate-leave'],
      )}
    >
      <div className="flex items-center gap-3">
        <CheckCircleIcon className={mergeClasses('size-6')} />
        <div className="flex flex-col gap-1">
          <div className={mergeClasses('break-normal', 'dark:!text-neutral-0')}>{message}</div>
          {subtitle && (
            <div
              className={mergeClasses(
                'break-normal text-body-xs text-opacity-light-70',
                'dark:!text-neutral-0',
              )}
            >
              {subtitle}
            </div>
          )}
        </div>
      </div>
      <button onClick={() => toaster.dismiss(t.id)}>
        <CloseIcon className="size-6 dark:text-neutral-0" />
      </button>
    </div>
  );
};

export default ToastSuccess;
